import React from "react";
import { CardBody, Container, Row } from "reactstrap";

 import { useTranslation } from "react-i18next";

import { useParams } from "react-router-dom";
import { UserListTableData } from "../../../../data/users/UsersList";
import UserInfo from "./UserInfo";
import UserOrganizationInfo from "./UserOrganizationInfo";
import Breadcrumbs from "../../../../common-elements/breadcrumbs/Breadcrumbs";

function ViewList() {
  const { id } = useParams();
  const { t } = useTranslation();
  const UserData = UserListTableData.find(
    (user: any) => user.id.toString() === id
  );

  return (
    <>
         <Breadcrumbs
        mainTitle= {t("ViewOrganizationAdmin")}
        parents={[
          { label: t("Users")},
          {
            label: t("organizationAdmin"),
            link: `${process.env.PUBLIC_URL}/users/organization-admin`,
          },
        ]}
      />
      <Container fluid>
        <div>
          <CardBody className="p-0">
            <Row className="list-persons" id="addIcon">
              {/* view section for user inf0 */}
              <UserInfo data={UserData} />
              {/* view section for organization info */}
              <UserOrganizationInfo data={UserData} />
            </Row>
          </CardBody>
        </div>
      </Container>
    </>
  );
}

export default ViewList;
